<script>
/**
 * 再資源化で共通利用するテーブル
 * componentsとして登録済なので個々でのimportは不要でっす。
 * emitの定義
 * replace:list => resultListの洗い替え
 */
import {mapActions} from "vuex";
import ChooseRecycleDisposalPatternModal from "@/driver/components/ChooseRecycleDisposalPatternModal.vue";
import EditRequestRatioModal from "@/driver/pages/masters/recycle_disposal_patterns/flows/modals/EditRequestRatioModal.vue";

export default {
  name: "RecycleStepTable",
  components: {
    EditRequestRatioModal,
    ChooseRecycleDisposalPatternModal,
  },
  props: {
    /**
     * ヘッダー
     * { value: "level", text: "階層", width: "5%" }
     * level: 階層
     * api_id: id
     * item_names: 処分前廃棄物種類
     * disposer: 処分業者/処分事業場
     * address: 処分事業場住所
     * item_type: 種別/処理前廃棄物の種類
     * disposal_method: 処分方法表示名称/処分方法コード1～4の名称
     * primary_disposal_method: 主たる処分方法/処分方法コード1～4の名称
     * before_disposal_ratio: 処分割合(v-text-field)
     * report_before_disposal_weight: 処分前重量(v-text-field)
     * recycle_disposed_item: 処理後物の大分類/処理後物の種類
     * after_disposal_ratio: 処理後割合(v-text-field)
     * report_after_disposal_weight: 処理後重量(v-text-field)
     * input_final_disposal_date: 最終処分終了日(picker)
     * add_next_step: 後工程(v-btn)
     * final_disposal: 最終処分(v-radio)
     *
     * comment: 備考
     * remove_action: 削除アイコン
     */
    headers: {
      type: Array,
      default: () => []
    },
    /**
     * 展開するリスト
     */
    resultList: {
      type: Array,
      default: () => []
    },
    /**
     * 編集モード
     */
    editableMode: {
      type: Boolean,
      default: false
    },
    /**
     * 読み取り専用
     */
    referenceOnly: {
      type: Boolean,
      default: false
    },
    /**
     * 処分事業者ID
     */
    disposerId: {
      type: Number,
      default: null
    },
    /**
     * 処分事業場ID
     */
    disposerLocationId: {
      type: Number,
      default: null
    },
    /**
     * 処分事業場コード
     */
    disposerLocationCode: {
      type: String,
      default: null
    },
    /**
     * 処分前廃棄物種類
     */
    itemIds: {
      type: Array,
      default: () => []
    },
    /**
     * エラー有無
     * 呼び出し元でリストに関するチェック処理
     */
    hasError: {
      type: Boolean,
      default: false
    },
    /**
     * 複写ボタンの表示設定
     */
    isFirstField: {
      type: Boolean,
      default: false
    },
    /**
     * 最終処分終了報告の編集可能かどうかを表すフラグ
     */
    targetForRegistration: {
      type: Boolean,
      default: true
    },
    /**
     * 数量
     */
    finalDisposalQuantity: {
      type: [String, Number],
      default: null
    },
    /**
     * 処分場処理方法 or 処理フローID
     */
    patternId: {
      type: Number,
      default: null,
    },
    /**
     * 種別
     * methods: 処分場処理方法
     * flows: 処理フロー
     */
    patternType: {
      type: String,
      default: null,
    },
    /**
     * 本コンポーネントの呼び出し元
     *
     *  masterMethod: 処分場処理方法マスタ
     *  masterFlow: 処理フローマスタ
     *  disposal: 処分終了報告
     *  finalDisposal: 最終処分終了報告
     */
    callSource: {
      type: String,
      default: null,
    },
    /**
     * 処分終了日に設定する選択可能最大日
     */
    finalDisposalMinimumDate: {
      type: String,
      default: null,
    },
    /**
    * 元の処分割合・処理後割合を非表示にするフラグ
    * true: 非表示
    * false: 表示
    */
    hideOriginRatio: {
      type: Boolean,
      default: false,
    }
  },
  data () {
    return {
      /**
       * 後工程追加モーダルの表示制御
       */
      enableNextStepModal: false,
      enableEditRequestRatioModal: false,
      targetOfSiblingChildren: [],
      systemDate: this.$dayjs().format("YYYY-MM-DD"),
      /**
       * 後工程追加ボタンや最終処分終了日をクリックした際に、どの行のボタンがクリックされたかを保持するための変数
       */
      targetKey: null,
      recycleDisposedItemId: null,
      isInitialized: false
    }
  },
  computed: {
    /**
     * ヘッダー情報からキーを抜き出す.
     * @return {any[]}
     */
    usesValues() {
      return this.headers.map(header => header.value);
    },

    modalConditions () {
      return {
        item_ids: this.itemIds,
      }
    },
  },
  watch: {
    /**
     * 数量の監視
     */
    finalDisposalQuantity: {
      handler () {
        if (!this.isInitialized) {
          this.isInitialized = true;
          return;
        }
        this.calculateFirstLayer();
      },
    },
    /**
     * パターンIDの監視
     */
    patternId (newValue) {
      if (newValue) {
        this.loadPattern();
      }
    },
    /**
     *
     */
    resultList: {
      handler (newValue) {
        if (newValue) {
          this.editableResultList()
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.isInitialized = true;
  },
  created() {},
  methods: {

    /**
     * 処理工程選択 再資源化等パターン
     */
    ...mapActions("DriverMasterSearchRecycleDisposalPattern", {
      fetchPattern: "show"
    }),

    /**
     * スナックバー
     */
    ...mapActions('snackbar', {
      showError: 'showError'
    }),

    /**
     * 後工程追加ボタン クリックイベント
     * @param member
     */
    addNextStepButtonClickEvent (member) {
      this.targetKey = member.key;
      this.recycleDisposedItemId = member.recycle_disposed_item_id;
      this.enableNextStepModal = true;
    },

    /**
     * 後工程削除ボタン クリックイベント
     * @param member
     */
    removeNextStepButtonClickEvent (member) {

      const targetIndex = this.resultList.findIndex(result => result.key === member.key);
      // 対象行の次から走査
      for (let i = targetIndex + 1; i < this.resultList.length; i++) {
        const result = this.resultList[i];
        /*
         * 自身と同一levelになったら終了
         * member.level: 1, target.level: 1  => break;
         */
        if (result.level === member.level) {
          break;
        }
        result._destroy = true
      }
      const replaceList = this.resultList.filter(member => !member._destroy);
      this.$emit("replace:list", replaceList);
      // 再計算
      this.recalculateRatio(member.key)
    },

    /**
     * 依頼割合設定モーダル呼出ボタン クリックイベント
     * 同じ処分場処理方法IDで依頼割合をまとめ、モーダル表示用の配列を生成する.
     * @param member { Object }
     */
    editRequestButtonClickEvent (member) {

      // console.log("editRequestButtonClickEvent in.")

      this.targetOfSiblingChildren = null;
      this.targetOfSiblingChildren = []

      /* 依頼割合設定ボタンが押下された行以下の子工程を取得 */
      const siblingChildren = this.fetchSiblingChildren(member.key, this.resultList);

      const parentMember = member;

      // 子工程を走査
      siblingChildren.forEach(child => {

        if (parentMember.level + 1 === child.level) {
          // targetOfSiblingChildrenに同処分場処理方法IDが存在するかチェック
          const sameMember = this.targetOfSiblingChildren.find(member => member.recycle_disposer_disposal_method_id === child.recycle_disposer_disposal_method_id);

          /*
           * 前工程の処分後割合を元に依頼割合を算出する。
           * 前工程の処分後割合: 12%
           * 対象の処分前割合が、6%の場合、依頼割合は 6% / 12% * 100 = 50%
           */

          // const calcRequestRatio = Number(this.roundHalfUp((Number(child.before_disposal_ratio) / Number(parentMember.after_disposal_ratio)) * 100, 1));
          const calcRequestRatio = Number(child.request_ratio)
          if (sameMember) {
            // 存在する場合は、依頼割合を加算
            sameMember.request_ratio = sameMember.request_ratio + calcRequestRatio;
          } else {
            // 存在しない場合は、処分場処理方法ID, 処分事業者名, 処分事業場名, 処分場処理方法名, 依頼割合を格納したHashをtargetOfSiblingChildrenに追加する.

            const requestRatio = parentMember.after_disposal_ratio === 0 ? 0 : calcRequestRatio;

            this.targetOfSiblingChildren.push(
              {
                recycle_disposer_disposal_method_id: child.recycle_disposer_disposal_method_id,
                disposer_name: child.disposer_name,
                disposer_location_name: child.disposer_location_name,
                recycle_disposer_disposal_method_name: child.recycle_disposer_disposal_method_name,
                request_ratio: requestRatio,
              }
            );
          }
        }
      })

      let total = 0;
      this.targetOfSiblingChildren.forEach(item => {
        total += item.request_ratio;
      })
      if (total > 100) {
        total = total - 100;
        // 配列の最後から依頼割合を減算していく
        for (let i = this.targetOfSiblingChildren.length - 1; i >= 0; i--) {
          const item = this.targetOfSiblingChildren[i];
          if (item.request_ratio > total) {
            item.request_ratio = item.request_ratio - total;
            break;
          } else {
            total = total - item.request_ratio;
            item.request_ratio = 0;
          }
        }
      } else if (total < 100) {
        total = 100 - total;
        // 配列の先頭から依頼割合を加算していく
        for (let i = 0; i < this.targetOfSiblingChildren.length; i++) {
          const item = this.targetOfSiblingChildren[i];
          if (item.request_ratio + total <= 100) {
            item.request_ratio = this.roundHalfUp(item.request_ratio + total, 1);
            break;
          } else {
            total = total - (100 - item.request_ratio);
            item.request_ratio = 100;
          }
        }
      }

      this.targetKey = member.key;
      this.enableEditRequestRatioModal = true;
    },

    /**
     * リスト削除ボタン クリックイベント
     * @param key
     */
    memberDeleteButtonClickEvent (key) {
      // 処分場処理方法は階層を持たないため、対象の1件のみ削除する
      if (this.callSource === 'masterMethod') {
        for (let i = 0; i < this.resultList.length; i++) {
          if (this.resultList[i].key === key) {
            this.resultList[i]._destroy = true
            break
          }
        }
        const replaceList = this.resultList.filter(member => !member._destroy)
        this.$emit("replace:list", replaceList)
        return
      }

      // 処理フローは階層構造のため、対象行と配下の子階層をまとめて削除する
      const targetIndex = this.resultList.findIndex(member => member.key === key);
      const target = this.resultList.find(member => member.key === key);

      let recalculateBaseKey = null;

      // 削除後の再計算のため、直上の親のkeyを保持
      for (let i = targetIndex - 1; i >= 0; i--) {
        if (this.resultList[i].level < target.level) {
          recalculateBaseKey = this.resultList[i].key;
          break;
        }
      }

      /*
       * 削除ボタンを押下した行からループスタート
       */
      for (let i = targetIndex; i < this.resultList.length; i++) {
        let member = this.resultList[i];
        /*
         * 同一キー or 対象行のレベルが削除ボタンを押下した行のレベルより上は削除とする
         * L.1
         * L.2 key: 123450 ← 削除ボタン押下行 キー一致
         * L.3 key: 123451 ← 削除ボタン押下行よりレベルが上
         * L.4 key: 123452 ← 削除ボタン押下行よりレベルが上
         * L.2 key: 123453 ← 削除ボタン押下行とレベルが同値なのでbreak
         * L.3 key: 123454 ← 上位でbreakされたので対象外
         * L.1 key: 123455 ← 上位でbreakされたので対象外
         */
        const canRemove = member.key === target.key || member.level >= target.level;
        if (canRemove) {
          member._destroy = true;
        } else {
          break;
        }
      }
      const replaceList = this.resultList.filter(member => !member._destroy);
      this.$emit("replace:list", replaceList);

      // 再計算
      this.recalculateRatio(recalculateBaseKey)
    },

    /**
     * 最終処分終了日 クリックイベント
     * クリックした行情報からキーを取得して保持
     * @param item { Object }
     * @return {boolean}
     */
    reportEndDayTextClickEvent(item) {
      this.targetKey = item.key
      return true;
    },

    /**
     * 処分割合 変更イベント
     * @param member
     */
    beforeDisposalRatioBlurEvent (member) {

      // 処分場処理方法登録では処理後割合の自動計算を行わない
      if (this.callSource === 'masterMethod') {
        return;
      }
      // 処分割合から処理後割合を再計算
      const num = (member.before_disposal_ratio / 100) * member.origin_after_disposal_ratio;
      if (isNaN(num)) {
        member.after_disposal_ratio = '-';
      } else {
        member.after_disposal_ratio = this.roundHalfUp(((num * 10) / 10), 1);
      }
      this.recalculateRatio(member.key)
    },

    /**
     * 処分後割合 変更イベント
     * @param member
     */
    afterDisposalRatioBlurEvent (member) {
      this.recalculateRatio(member.key)
    },

    /**
     * 処理前重量 変更イベント
     * @param member
     */
    reportBeforeDisposalWeightBlurEvent (member) {
      if (member.level === 1 ) {
        const after_disposal_weight = (this.finalDisposalQuantity / 100) * member.origin_after_disposal_ratio;
        if (isNaN(after_disposal_weight)) {
          member.after_disposal_weight = '-'
        } else {
          member.after_disposal_weight = this.roundHalfUp(((after_disposal_weight * 1000) / 1000), 3)
        }

      } else {
        const num = member.before_disposal_weight * member.origin_after_disposal_ratio / member.original_before_disposal_ratio;
        if (isNaN(num)) {
          member.after_disposal_weight = '-'
        } else {
          member.after_disposal_weight = this.roundHalfUp(((num * 1000) / 1000), 3)
        }
      }
      this.recalculateWeight(member.key)

    },

    /**
     * 処理後重量 変更イベント
     * @param member
     */
    reportAfterDisposalWeightBlurEvent (member) {
      this.recalculateWeight(member.key)
    },

    /**
     * 処分終了日ピッカー コールバック処理
     * @param date { String }
     */
    disposalReportEndDateChangedCallback (date) {
      const row = this.resultList.find(item => item.key === this.targetKey)
      if (row) {
        row.final_disposal_date = date;
      }
      this.targetKey = null;
    },

    /**
     * 後工程追加モーダル 閉じるボタン コールバック
     */
    modalNegativeCallback () {
      this.enableNextStepModal = false;
      this.enableEditRequestRatioModal = false;
      this.targetKey = null;
    },

    /**
     * 後工程追加モーダル 登録ボタン コールバック
     * @param item
     */
    modalPositiveCallback (item) {

      // パターン種別(methods: 処分場処理方法, flows: 処理フロー)
      this.fetchPattern({ id: item.pattern.id, type: item.pattern.type }).then((content) => {

        /*
         * 後工程追加ボタンが押下された工程の後に続く+1した工程を抽出
         * 抽出した結果が持つ処分場処理方法IDを重複なしで配列化
         */
        const patternDetails = content.pattern_details;

        /*
          後工程追加を行うにあたり、同一工程で同じ処分場処理方法の追加は行えないように制御を行う.
         */
        const beforeAddingMethodIds = this.fetchSiblingUniqueMethodIds(this.targetKey, this.resultList);
        const addResult = patternDetails.filter(value => value.level === 1)
        const addMethodIds = Array.from(new Set(addResult.map(item => item.recycle_disposer_disposal_method_id )))

        const hasMatch = beforeAddingMethodIds.some(item => addMethodIds.includes(item));
        if (hasMatch) {
          this.showError({ message: "同工程で処分場処理方法が重複するので反映できません。" })
          return;
        }

        if (this.callSource === 'masterFlow') {
          /**
           * ■ 処理フローマスタからの呼出時の制御
           */

          /*
            取得結果をリストにマージ
          */
          this.appendRows(patternDetails);

          if (item.pattern.type === 'methods') {

            // 後工程追加ボタンが押下された工程の後に続く+1した工程を抽出
            const siblings = this.fetchSiblingChildren(this.targetKey, this.resultList)
            // 抽出結果から処分場処理方法IDを重複なしで抽出
            const siblingMethodIds = Array.from(new Set(siblings.map(item => item.recycle_disposer_disposal_method_id )));

            if (siblingMethodIds.length === 1) {
              // 抽出した処分場処理方法IDの配列要素が1つの場合
              const key = siblingMethodIds[0];
              siblings.forEach(item => {
                if (item.recycle_disposer_disposal_method_id === key) {
                  item.request_ratio = item.before_disposal_ratio;
                  item.enable_request_ratio = true;
                }
              })
            } else {
              // 抽出した処分場処理方法IDの配列要素が複数の場合
              const siblingMethodIds = Array.from(new Set(addResult.map(item => item.recycle_disposer_disposal_method_id )));
              siblings.forEach(item => {
                if (siblingMethodIds.includes(item.recycle_disposer_disposal_method_id)) {
                  item.before_disposal_ratio = null;
                  item.request_ratio = null;
                  item.enable_request_ratio = true;
                }
              })
            }
          } else {
            const keys = patternDetails.map(item => item.key)
            this.resultList.forEach(item => {
              if (keys.includes(item.key)) {
                item.enable_request_ratio = true;
              }
            })
          }

        } else {
          /**
           * ■ 処理フローマスタ以外からの呼出時の制御
           */
          if (this.callSource === 'finalDisposal') {

            /**
             * 処分割合・処理後割合の再計算
             * @param key { Number, String } 起点となるキー
             * @param list { Array } 再計算対象のリスト
             */
            const updateResultRatios = (key, list) => {
              const startItem = list.find(member => member.key === key);
              list.forEach((item, _) => {
                if (item.level === startItem.level + 1) {
                  item.before_disposal_ratio = this.roundHalfUp(startItem.after_disposal_ratio * item.origin_before_disposal_ratio / 100, 1);
                  item.after_disposal_ratio = this.roundHalfUp(item.before_disposal_ratio * item.origin_after_disposal_ratio / item.origin_before_disposal_ratio, 1);
                  updateResultRatios(item.key, list)
                }
              })
            }

            const children = this.fetchSiblingChildren(this.targetKey, this.resultList);
            const startItem = this.resultList.find(member => member.key === this.targetKey);
            if (children.length === 0) {
              patternDetails.forEach((item, _) => {
                if (item.level === 1) {
                  item.before_disposal_ratio = this.roundHalfUp(startItem.after_disposal_ratio * item.origin_before_disposal_ratio / 100, 1);
                  item.after_disposal_ratio = this.roundHalfUp(item.before_disposal_ratio * item.origin_after_disposal_ratio / item.origin_before_disposal_ratio, 1);

                  updateResultRatios(item.key, patternDetails)
                }
              })
            } else {
              patternDetails.forEach((item, _) => {
                if (item.level === 1) {
                  item.before_disposal_ratio = 0
                  item.after_disposal_ratio = 0
                  item.request_ratio = 0
                  updateResultRatios(item.key, patternDetails)
                }
              })
            }
          }
          this.appendRows(patternDetails);
        }

        if (this.callSource !== 'finalDisposal' && this.usesValues.includes('before_disposal_ratio')) {
          this.recalculateRatio(this.targetKey)
        } else {
          this.recalculateWeight(this.targetKey)
        }

        this.targetKey = null;
        this.modalNegativeCallback();
      })
    },



    /**
     * 依頼割合設定モーダル コールバック
     * 返却されたリストを元に依頼割合, 処分割合を再計算する.
     * @param items { Array }
     * @param items.recycle_disposer_disposal_method_id { Number } 処分場処理方法ID
     * @param items.request_ratio { Number } 依頼割合
     */
    editRequestRatioModalCallback (items) {
      /*
       * items: [ { recycle_disposer_disposal_method_id: 1, request_ratio: 50 }, { recycle_disposer_disposal_method_id: 2, request_ratio: 50 } ]
       */
      const target = this.resultList.find(item => item.key === this.targetKey);
      const siblingChildren = this.fetchSiblingChildren(this.targetKey, this.resultList);

      const targetLevel = target.level + 1;

      // console.log('対象の工程', targetLevel)

      items.forEach((item) => {
        siblingChildren.forEach(child => {

          if (item.recycle_disposer_disposal_method_id === child.recycle_disposer_disposal_method_id && child.level === targetLevel) {
            // console.log("現在の工程", child.level, "キー", child.key)
            // 依頼割合を算出
            // 依頼割合: モーダルで入力された依頼割合 * 処分場処理方法の処分割合 / 100
            child.request_ratio = this.roundHalfUp(item.request_ratio * ( child.origin_before_disposal_ratio / 100 ), 1)

            const beforeDisposalRatio = target.after_disposal_ratio * child.request_ratio / 100;
            // console.log(`${item.after_disposal_ratio} * ${item.request_ratio} / 100 = ${beforeDisposalRatio}`)
            child.before_disposal_ratio = this.roundHalfUp(beforeDisposalRatio, 1);
            // 自工程の処分割合
            const afterDisposalRatio = child.before_disposal_ratio * child.origin_after_disposal_ratio / child.origin_before_disposal_ratio;
            // console.log(`${item.before_disposal_ratio} * ${item.origin_after_disposal_ratio} / ${item.origin_before_disposal_ratio} = ${afterDisposalRatio}`)
            if (isNaN(afterDisposalRatio)) {
              // console.log("ナンです")
              item.after_disposal_ratio = '-';
            } else {
              item.after_disposal_ratio = this.roundHalfUp(afterDisposalRatio, 1);
            }


          }
        })
      })
      this.recalculateRatio(target.key)

      if (this.callSource === 'finalDisposal' && !this.usesValues.includes('before_disposal_ratio')) {
        this.recalculateWeight(target.key)
      }

      this.modalNegativeCallback();
    },

    /**
     * 1階層目の再計算
     * 数量変更時に発火
     */
    calculateFirstLayer () {
      if (this.usesValues.includes('before_disposal_ratio')) {
        return;
      }
      const firstLayers = this.resultList.filter(member => member.level === 1);
      if (firstLayers.length > 0) {
        firstLayers.forEach((item, _) => {
          const before_disposal_weight = this.finalDisposalQuantity * item.before_disposal_ratio / 100;
          if (isNaN(before_disposal_weight) || before_disposal_weight === 0) {
            item.before_disposal_weight = null
          } else {
            item.before_disposal_weight = this.roundHalfUp(before_disposal_weight, 3)
          }

          const after_disposal_weight = this.finalDisposalQuantity * item.after_disposal_ratio / 100;
          if (isNaN(after_disposal_weight) || after_disposal_weight === 0) {
            item.after_disposal_weight = null

          } else {
            item.after_disposal_weight = this.roundHalfUp(after_disposal_weight, 3)

          }
          this.recalculateWeight(item.key);
        })
      }
    },

    /**
     * パターンのロード
     */
    loadPattern () {
      this.fetchPattern({ id: this.patternId, type: this.patternType }).then((content) => {
        const patternDetails = content.pattern_details;
        patternDetails.forEach(item => {
          item.request_ratio = item.before_disposal_ratio;
        })
        this.$emit("replace:list", content.pattern_details);
        this.$nextTick(() => {
            this.calculateFirstLayer()
            this.editableResultList()
          }
        );
      })
    },

    /**
     * リストにメンバーを追加する
     * @param items { Array } 追加するリスト
     */
    appendRows (items) {
      let targetIndex = this.resultList.findIndex(member => member.key === this.targetKey);
      targetIndex = targetIndex + 1;

      const parent = this.resultList.find(member => member.key === this.targetKey);
      if (!parent) {
        return;
      }

      let startLevel = parent.level;

      let addInIndex = 0;
      for (let i = targetIndex; i < this.resultList.length; i++) {
        if (this.resultList[i]._destroy) {
          continue;
        }
        if (this.resultList[i].level <= parent.level) {
          addInIndex = i;
          break;
        }
      }

      if (addInIndex === 0) {
        addInIndex = this.resultList.length;
      }
      items.forEach((item, _) => {
        item.level = startLevel + item.level
        item.id = null;
        this.resultList.splice(addInIndex, 0, item);
        addInIndex += 1;
      })

      this.resultList.forEach((item, index) => {
        item.sort_priority = index + 1;
      })
    },

    /**
     * 重量の再計算を行う
     * @param changedPointKey { Number } 値を変更した行が持つキー
     */
    recalculateWeight (changedPointKey) {
      const startItem = this.resultList.find(member => member.key === changedPointKey);
      let startIndex = this.resultList.findIndex(member => member.key === changedPointKey);
      startIndex += 1;
      const startLevel = startItem.level;
      const children = [];
      const targetLevel = startLevel + 1;

      // 自階層+1の子階層を抽出
      for (let i = startIndex; i < this.resultList.length; i++) {
        if (this.resultList[i].level === targetLevel) {
          children.push(this.resultList[i]);
        } else if (this.resultList[i].level <= startLevel) {
          break;
        }
      }

      // 子階層の処分前重量と処理後重量を設定
      children.forEach((item, _) => {
        const beforeDisposalWeight = this.finalDisposalQuantity * (item.before_disposal_ratio / 100)
        item.before_disposal_weight = this.roundHalfUp(beforeDisposalWeight, 3);
        const num = this.finalDisposalQuantity * (item.after_disposal_ratio / 100) // ←ここ
        if (isNaN(num) || num === 0) {
          item.after_disposal_weight = null
        } else {
          item.after_disposal_weight = this.roundHalfUp(num, 3)
        }
        this.recalculateWeight(item.key);
      })
    },

    /**
     * 割合の再計算を行う
     * @param changedPointKey { Number } 値を変更した行が持つキー
     * @param stopRequest { Boolean } 依頼割合の計算を止めるかどうか
     */
    recalculateRatio (changedPointKey, stopRequest=false) {
      const startItem = this.resultList.find(member => member.key === changedPointKey);
      let startIndex = this.resultList.findIndex(member => member.key === changedPointKey);

      startIndex += 1;
      // const startLevel = startItem.level;
      // const children = [];
      // const targetLevel = startLevel + 1;
      // let totalOfBeforeDisposalRatio = 0;

      /*
       * 自階層+1の子階層を抽出
       * 01: 追加ボタン押下元
       * 02: 対象
       * 03: 対象外
       * 02: 対象
       * 03: 対象外
       * 04: 対象外
       * 01: ここから以下対象外
       */
      const children = this.fetchSiblingChildren(changedPointKey, this.resultList);

      children.forEach((item, _) => {
        // 追加元の処理後割合から処分割合を算出
        if (!item._destroy) {
          if (this.callSource === 'masterFlow' && !item.request_ratio && item.enable_request_ratio) {
            item.after_disposal_ratio = 0;
          } else {

            let beforeDisposalRatio = 0
            if (stopRequest) {
              beforeDisposalRatio = startItem.after_disposal_ratio * item.origin_before_disposal_ratio / 100;
            } else {
              beforeDisposalRatio = startItem.after_disposal_ratio * item.request_ratio / 100;

            }
            item.before_disposal_ratio = this.roundHalfUp(beforeDisposalRatio, 1);
            // 自工程の処分割合
            const afterDisposalRatio = item.before_disposal_ratio * item.origin_after_disposal_ratio / item.origin_before_disposal_ratio;
            // console.log(`${item.before_disposal_ratio} * ${item.origin_after_disposal_ratio} / ${item.origin_before_disposal_ratio} = ${afterDisposalRatio}`)
            if (isNaN(afterDisposalRatio)) {
              item.after_disposal_ratio = '-';
            } else {
              item.after_disposal_ratio = this.roundHalfUp(afterDisposalRatio, 1);
            }

          }
          this.recalculateRatio(item.key, true);
        }
      })
    },

    /**
     * 処分割合の編集可否
     * @return {boolean}
     */
    canEditBeforeRatio () {
      // 参照モードはNG
      if (this.referenceOnly) {
        return false;
      }

      // 呼び出し元が処理フローで、第一階層はNG
      return !(this.callSource === 'masterFlow');
    },

    /**
     * 処理後割合の編集可否
     * @return {boolean}
     */
    canEditAfterRatio () {
      // 参照モードはNG
      if (this.referenceOnly) {
        return false;
      }
      // 呼び出し元が処理フローはNG
      return this.callSource !== 'masterFlow';
    },

    /**
     * 最終処分終了日の入力欄表示可否
     * 処分終了報告画面では最終処分フラグに関わらず入力欄を表示する
     * @param member
     * @return {boolean}
     */
    canShowFinalDisposalDateInput (member) {
      if (this.referenceOnly) {
        return false;
      }

      if (this.callSource === 'disposal') {
        return true;
      }

      return !!member.final_disposal;
    },

    canShowFinalDisposalLabel(member) {
      const head = this.headers.find(v => v.value === 'recycle_disposed_item')
      if (head && head?.show_final_disposal_label) {
        return member.final_disposal;
      }
      return false;
    },

    /**
     * リストの更新を行う.
     * 処理フローマスタからの呼出で、
     */
    editableResultList () {
      if (!['masterFlow', 'finalDisposal'].includes(this.callSource)) {
        return;
      }

      for (let i = 0; i <= this.resultList.length; i++) {
        const item = this.resultList[i];
        if (item._destroy) {
          continue;
        }
        const siblingChildren = this.fetchSiblingChildren(item.key, this.resultList);
        const siblingMethodIds = this.fetchSiblingUniqueMethodIds(item.key, this.resultList)
        item.has_sibling_children = siblingMethodIds.length >= 2;
        item.has_children = siblingChildren.length > 0;
      }
    },

    /**
     * 直下の次工程を取得する
     * @param key
     * @param list { Array } 解析する配列
     * @return {*[]}
     */
    fetchSiblingChildren (key, list = []) {
      const targetIndex = list.findIndex(member => member.key === key);
      const target = list[targetIndex];
      if (!target) {
        return [];
      }
      const targetLevel = target.level + 1;
      let children = [];
      // 対象行の次から走査
      for (let i = targetIndex + 1; i < list.length; i++) {
        const member = list[i];

        if (member._destroy) {
          continue;
        }

        /*
         * 自身と同一level、または自身より上位のlevelになったら終了
         * member.level: 1, target.level: 1  => break;
         * member.level: 2, target.level: 1  => 続行;
         */
        if (member.level <= target.level) {
          break;
        }
        // 自身のlevel + 1 のデータをカウント
        if (member.level === targetLevel) {
          children.push(member);
        }
      }
      return children;
    },

    /**
     * 指定key直下の次工程内の処分場処理方法IDを配列で返す.
     * 重複している場合はマージ
     * @param key { Number } 起点となる工程のキー
     * @param list { Array } 解析する配列
     * @return {any[]}
     */
    fetchSiblingUniqueMethodIds (key, list = []) {
      const siblingChildren = this.fetchSiblingChildren(key, list);
      return Array.from(new Set(siblingChildren.map(item => item.recycle_disposer_disposal_method_id )));
    },

    /**
     * 品目名の表示フォーマット
     * @param member
     * @return {*|string}
     */
    formatItemNames (member) {
      if (Array.isArray(member?.item_names)) {
        return member.item_names.join('/')
      }
      return member?.item_name || ''
    },

    /**
     * 処分方法の表示フォーマット
     * @param member
     * @return {*|string}
     */
    formatAfterDisposalMethodNames (member) {
      if (Array.isArray(member?.after_disposal_method_names)) {
        return member.after_disposal_method_names.join('/')
      }
      return ''
    },

  },
}
</script>

<template>
  <div>
    <v-sheet
      :class="{ 'error-border': hasError }"
      :color="hasError ? 'error' : '' "
      outlined
      rounded
    >
      <v-simple-table
        class="pa-0"
        :class=" { '': !targetForRegistration }"
      >
        <template v-slot:default>
          <thead>
          <tr>
            <th
              v-for="(column, index) in headers"
              :key="index"
              :style="`width: ${column.width};`"
              :class="{ 'text-center': [
                'add_next_step',
                'api_id',
                'level',
                'before_disposal_ratio',
                'after_disposal_ratio',
                'report_before_disposal_weight',
                'report_after_disposal_weight'].includes(column.value) }"
            >
              {{ column.text }}
            </th>
          </tr>
          </thead>
          <tbody
            v-if="resultList.length > 0"
          >
            <tr
              v-for="(member, index) in resultList"
              :key="`row_${member.key || index}`"
            >
              <td
                v-for="(fieldKey, inx) in usesValues"
                :key="`column_${index}_${inx}`"
                :class="{ 'pt-1': ['report_before_disposal_weight', 'report_after_disposal_weight'].includes(fieldKey) }"
              >
                <!-- 階層 -->
                <template v-if="fieldKey === 'level'">
                  <div class="text-center">
                    <v-chip
                      class="text-center"
                      :class="levelBackgroundColor(member)"
                      small
                      style="width: 100%;display: inline-block"
                    >
                      {{ `${member.level}`.padStart(2, '0') }}
                    </v-chip>
                  </div>
                </template>
                <!-- /階層 -->

                <!-- API-ID -->
                <template v-else-if="fieldKey === 'api_id'">
                  <div class="text-center">
                    {{ member.id }}
                  </div>
                </template>
                <!-- /API-ID -->

                <!-- 処分前廃棄物種類 -->
                <template v-else-if="fieldKey === 'item_names'">
                  <div
                    :title="formatItemNames(member)"
                    class="label-font line-clamp three-clamp"
                  >
                    {{ formatItemNames(member) }}
                  </div>
                </template>

                <template v-else-if="fieldKey === 'item_name'">
                  <div class="label-font">
                    {{ member.item_name }}
                  </div>
                </template>
                <!-- /処分前廃棄物種類 -->

                <!-- 処分事業者, 処分事業場, 依頼割合 -->
                <template v-else-if="fieldKey === 'disposer'">
                  <div>
                    <div
                      :title="member.disposer_name"
                      class="label-font line-clamp one-clamp"
                    >
                      {{ member.disposer_name }}
                      <v-tooltip
                        v-if="member.disposer_address"
                        top
                        :open-on-hover="false"
                      >
                        <template #activator="{ on }">
                          <v-btn
                            icon
                            tile
                            x-small
                            retain-focus-on-click
                            class="map-icon"
                            @click="on.click"
                            @blur="on.blur"
                          >
                            <v-icon small>mdi-map-marker-outline</v-icon>
                          </v-btn>
                        </template>
                        <div>
                          <small>{{ member.disposer_address }}</small>
                        </div>
                      </v-tooltip>
                    </div>
                    <div
                      :title="member.disposer_location_name"
                      class="label-font line-clamp one-clamp"
                    >
                      {{ member.disposer_location_name }}
                      <v-tooltip top :open-on-hover="false">
                        <template #activator="{ on }">
                          <v-btn
                            icon
                            tile
                            x-small
                            retain-focus-on-click
                            class="map-icon"
                            @click="on.click"
                            @blur="on.blur"
                          >
                            <v-icon small>mdi-map-marker-outline</v-icon>
                          </v-btn>
                        </template>
                        <div>
                          <small>{{ member.disposer_location_address }}</small>
                        </div>
                      </v-tooltip>
                    </div>
                    <div v-if="callSource === 'masterFlow'">
                      <div v-if="member.enable_request_ratio && member.level > 1" class="grey--text">
                        <template>
                          <small>{{ member.recycle_disposer_disposal_method_name }}（{{ member.request_ratio || 0 }}<span class="mt-1 ">&#37;</span>）</small>
                        </template>
                        &nbsp;
                        <validation-provider
                          v-slot="{ errors: detailErrors }"
                          :vid="`request_ratio-${ member.key }`"
                          :model-value="member.request_ratio"
                          name="依頼割合"
                          :rules="{ required: true }"
                        >
                          <div>
                            <v-input
                              v-model="member.request_ratio"
                              :error-messages="detailErrors"
                              dense
                              outlined
                              readonly
                              hide-details="auto"
                            >
                              <template v-slot:message>
                                <div class="ml-2">
                                  <p v-for="(message, index) in detailErrors" :key="index" class="mb-0 red--text">{{ message }}</p>
                                </div>
                              </template>
                            </v-input>
                          </div>
                        </validation-provider>
                      </div>
                      <div v-if="callSource === 'masterFlow' && member.level === 1" class="grey--text">
                        <small>{{ member.recycle_disposer_disposal_method_name }}</small>
                      </div>
                    </div>
                  </div>
                </template>
                <!-- /処分事業者, 処分事業場, 依頼割合 -->

                <!-- 種別, 処理前廃棄物の種類 -->
                <template v-else-if="fieldKey === 'item_type'">
                  <div>
                    <div
                      :title="member.after_item_type_name"
                      class="label-font"
                    >
                      {{ member.after_item_type_name }}
                    </div>
                    <div
                      :title="formatItemNames(member)"
                      class="label-font line-clamp three-clamp"
                    >
                      {{ formatItemNames(member) }}
                    </div>
                  </div>
                </template>
                <!-- /種別, 処理前廃棄物の種類 -->

                <!-- 処分割合 -->
                <template v-else-if="fieldKey === 'before_disposal_ratio'">
                  <div
                    v-if="canEditBeforeRatio()"
                    class="pt-1"
                  >
                    <validation-provider
                      v-slot="{ errors }"
                      :vid="`before_disposal_ratio-${ member.key }`"
                      name="処分割合"
                      :rules="{
                      required: true,
                      double: true,
                      min_value: 0.1,
                      max_value: 100,
                      quantityWithDecimal: { int_digits: 3, dec_digits: 1 },
                      }"
                    >
                      <v-text-field
                        v-model="member.before_disposal_ratio"
                        :error-messages="errors"
                        dense
                        type="number"
                        reverse
                        hide-details="auto"
                        outlined
                        persistent-placeholder
                        class="recycle-input"
                        @input="beforeDisposalRatioBlurEvent(member)"
                      >
                        <template v-slot:prepend-inner>
                          <span class="mt-1 ml-2">&#37;</span>
                        </template>
                      </v-text-field>
                    </validation-provider>
                  </div>
                  <div v-else>
                    <div class="text-center">{{ member.before_disposal_ratio || 0 }}&#37;</div>
                  </div>
                  <div v-if="!hideOriginRatio" class="text-center grey--text percent-font">
                    ({{ member.origin_before_disposal_ratio }}&#37;)
                  </div>
                </template>
                <!-- /処分割合 -->

                <!-- 処分前重量 -->
                <template v-else-if="fieldKey === 'report_before_disposal_weight'">
                  <div v-if="!referenceOnly">
                    <div>
                      <validation-provider
                        v-slot="{ errors }"
                        :vid="`before_disposal_weight-${ member.key }`"
                        name="処分前重量"
                        :rules="{
                        required: true,
                        double: true,
                        min_value: 0.001,
                        max_value: 9999999999.999,
                        quantityWithDecimal: { int_digits: 10, dec_digits: 3 },
                        }"
                      >
                        <v-text-field
                          v-model="member.before_disposal_weight"
                          :error-messages="errors"
                          :disabled="!targetForRegistration"
                          dense
                          type="number"
                          reverse
                          hide-details="auto"
                          outlined
                          persistent-placeholder
                          class="recycle-input"
                          @input="reportBeforeDisposalWeightBlurEvent(member)"
                        >
                          <template v-slot:prepend-inner>
                            <span class="mt-1 ml-2">kg</span>
                          </template>
                        </v-text-field>
                      </validation-provider>
                    </div>
                    <div class="text-center grey--text percent-font">
                      ({{ member.before_disposal_ratio }}&#37;)
                      <template v-if="false">
                        <br />({{ member.origin_before_disposal_ratio }}&#37;)<br />({{ member.request_ratio }}&#37;)
                      </template>
                    </div>
                  </div>
                  <div v-else>
                    {{ member.before_disposal_weight }}&nbsp;kg
                  </div>
                </template>
                <!-- /処分前重量 -->

                <!-- 処分方法表示名称, 処分方法コード1～4の名称 -->
                <template v-else-if="fieldKey === 'disposal_method'">
                  <div>
                    <div
                      :title="member.recycle_disposal_method_name"
                      class="label-font"
                    >
                      {{ member.recycle_disposal_method_name }}
                    </div>
                    <div>
                      <small
                        :title="formatAfterDisposalMethodNames(member)"
                        class="text--disabled line-clamp one-clamp"
                      >
                        {{ formatAfterDisposalMethodNames(member) }}
                      </small>
                    </div>
                  </div>
                </template>
                <!-- /処分方法表示名称, 処分方法コード1～4の名称 -->

                <!-- 主たる処分方法, 処分方法コード1～4の名称 -->
                <template v-else-if="fieldKey === 'primary_disposal_method'">
                  <div>
                    <div
                      :title="member.primary_after_disposal_method_name"
                      class="label-font"
                    >
                      {{ member.primary_after_disposal_method_name }}
                    </div>
                    <div :title="formatAfterDisposalMethodNames(member)">
                      <small class="text--disabled line-clamp one-clamp">{{ formatAfterDisposalMethodNames(member) }}</small>
                    </div>
                  </div>
                </template>
                <!-- /主たる処分方法, 処分方法コード1～4の名称 -->

                <!-- 処理後割合 -->
                <template v-else-if="fieldKey === 'after_disposal_ratio'">
                  <div>
                    <div v-if="canEditAfterRatio()">
                      <validation-provider
                        v-slot="{ errors }"
                        :vid="`after_disposal_ratio-${ member.key }`"
                        name="処理後割合"
                        :rules="{
                      required: true,
                      double: true,
                      min_value: 0.1,
                      quantityWithDecimal: { int_digits: 3, dec_digits: 1 },
                      }"
                      >
                        <v-text-field
                          v-model="member.after_disposal_ratio"
                          :error-messages="errors"
                          dense
                          type="number"
                          reverse
                          hide-details="auto"
                          outlined
                          persistent-placeholder
                          class="recycle-input"
                          @input="afterDisposalRatioBlurEvent(member)"
                        >
                          <template v-slot:prepend-inner>
                            <span class="mt-1 ml-2">&#37;</span>
                          </template>
                        </v-text-field>
                      </validation-provider>
                    </div>
                    <div v-else class="text-center">{{ member.after_disposal_ratio }}&#37;</div>
                  </div>
                  <div v-if="!hideOriginRatio" class="text-center grey--text percent-font">
                    ({{ member.origin_after_disposal_ratio }}&#37;)
                  </div>
                </template>
                <!-- /処理後割合 -->

                <!-- 処分後重量 -->
                <template v-else-if="fieldKey === 'report_after_disposal_weight'">
                  <div v-if="!referenceOnly">
                    <div>
                      <validation-provider
                        v-slot="{ errors }"
                        :vid="`after_disposal_weight-${ member.key }`"
                        name="処理後重量"
                        :rules="{
                        required: true,
                        double: true,
                        min_value: 0.001,
                        max_value: 99999999999.999,
                        quantityWithDecimal: { int_digits: 11, dec_digits: 3 },
                        }"
                      >
                        <v-text-field
                          v-model="member.after_disposal_weight"
                          :error-messages="errors"
                          :disabled="!targetForRegistration"
                          dense
                          type="number"
                          reverse
                          hide-details="auto"
                          outlined
                          persistent-placeholder
                          class="recycle-input"
                          @input="reportAfterDisposalWeightBlurEvent(member)"
                        >
                          <template v-slot:prepend-inner>
                            <span class="mt-1 ml-2">kg</span>
                          </template>
                        </v-text-field>
                      </validation-provider>
                    </div>
                    <div class="text-center grey--text percent-font">
                      ({{ member.after_disposal_ratio }}&#37;)
                    </div>
                  </div>
                  <div v-else>
                    {{ member.after_disposal_weight }} kg
                  </div>
                </template>
                <!-- /処分後重量 -->

                <!-- 処理後物の大分類, 処理後物の種類 -->
                <template v-else-if="fieldKey === 'recycle_disposed_item'">
                  <div>
                    <div
                      :title="member.recycle_disposed_item_parent_name"
                      class="label-font"
                    >
                      {{ member.recycle_disposed_item_parent_name }}
                    </div>
                    <div
                      :title="member.recycle_disposed_item_name"
                      class="label-font"
                    >
                      {{ member.recycle_disposed_item_name }}&nbsp;
                      <small>
                        <span class="text--disabled">
                          {{ member.after_type_label }}<span v-if="canShowFinalDisposalLabel(member)">(最終)</span>
                        </span>
                      </small>
                    </div>
                  </div>
                </template>
                <!-- /処理後物の大分類, 処理後物の種類 -->

                <!-- 後工程追加/削除ボタン -->
                <template v-else-if="fieldKey === 'add_next_step'">
                  <div class="text-center">
                    <v-btn
                      :disabled="!targetForRegistration || editableMode || referenceOnly || member.final_disposal"
                      color="primary"
                      x-small
                      style="height: 30px;"
                      @click="addNextStepButtonClickEvent(member)"
                    >
                      後工程追加
                    </v-btn>
                    &nbsp;
                    <v-btn
                      :disabled="!member.has_children || !targetForRegistration || editableMode || referenceOnly || member.final_disposal"
                      color="error"
                      x-small
                      style="height: 30px;"
                      @click="removeNextStepButtonClickEvent(member)"
                    >
                      後工程削除
                    </v-btn>
                  </div>
                </template>
                <!-- /後工程追加/削除ボタン -->

                <!-- 最終処分 -->
                <template v-else-if="fieldKey === 'final_disposal'">
                  <div class="d-flex align-center">
                    <v-radio-group
                      v-model="member.final_disposal"
                      :disabled="
                        referenceOnly ||
                        editableMode ||
                        member.after_type === 'after_recycling' ||
                        callSource === 'finalDisposal' ||
                        callSource === 'masterFlow' ||
                        member?.method_has_final_disposal"
                      dense
                      hide-details="auto"
                      row
                      persistent-hint
                      class="mt-0"
                    >
                      <v-radio
                        :ripple="false"
                        :value="false"
                      >
                        <template v-slot:label>
                          <span class="text-body-2">中間</span>
                        </template>
                      </v-radio>
                      <v-radio
                        :ripple="false"
                        :value="true"
                      >
                        <template v-slot:label>
                          <span class="text-body-2">最終</span>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </div>
                </template>
                <!-- /最終処分 -->

                <!-- 処分終了日 -->
                <template v-else-if="fieldKey === 'input_final_disposal_date'">
                  <div v-if="!referenceOnly">
                    <div v-if="canShowFinalDisposalDateInput(member)">
                      <cs-date-picker
                        :date.sync="member.final_disposal_date"
                        :disabled="!targetForRegistration"
                        :minimum-date="finalDisposalMinimumDate"
                        :maximum-date="systemDate"
                        @dateChangedCallback="disposalReportEndDateChangedCallback"
                      >
                        <template v-slot="{ on, attrs }">
                          <validation-provider
                            v-slot="{ errors }"
                            :disabled="!targetForRegistration"
                            :vid="`final_disposal_date-${member.key}`"
                            class="requiredMark"
                            name="処分終了日"
                            rules="required"
                          >
                            <v-text-field
                              v-model="member.final_disposal_date"
                              v-bind="attrs"
                              v-on="on"
                              :disabled="!targetForRegistration"
                              :error-messages="errors"
                              append-icon="mdi-calendar"
                              clearable
                              dense
                              hide-details="auto"
                              outlined
                              persistent-placeholder
                              readonly
                              class="recycle-input"
                              @click="reportEndDayTextClickEvent(member)"
                            />
                          </validation-provider>
                        </template>
                      </cs-date-picker>
                    </div>
                  </div>
                  <div v-else>
                    {{ member.final_disposal_date | date_format }}
                  </div>
                </template>
                <!-- /処分終了日 -->

                <!-- 備考 -->
                <template v-else-if="fieldKey === 'comment'">
                  <div v-if="!referenceOnly">
                    <validation-provider
                      v-slot="{ errors }"
                      :vid="`comment-${member.key}`"
                      rules="max:25"
                      name="備考"
                    >
                      <v-text-field
                        v-model="member.comment"
                        :disabled="!targetForRegistration || referenceOnly"
                        :error-messages="errors"
                        dense
                        hide-details="auto"
                        clearable
                        outlined
                        persistent-placeholder
                        class="recycle-input"
                      >
                        <template v-slot:label>
                        <span class="ml-1">
                      ({{ member.comment?.length || 0 }} / 25)
                    </span>
                        </template>
                      </v-text-field>
                    </validation-provider>
                  </div>
                  <div
                    v-else
                    :title="member.comment"
                    class="line-clamp one-clamp"
                  >
                    {{ member.comment }}
                  </div>
                </template>
                <!-- /備考 -->

                <!-- 削除ボタン -->
                <template v-else-if="['remove_action'].includes(fieldKey)">
                  <div>
                    <v-btn
                      v-if="!referenceOnly && !editableMode && (callSource === 'masterMethod' || member.level > 1)"
                      :disabled="!targetForRegistration"
                      :icon="$vuetify.breakpoint.mdAndUp"
                      :small="$vuetify.breakpoint.smAndDown"
                      :color="`error ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                      @click="memberDeleteButtonClickEvent(member.key)"
                    >
                      <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                        mdi-trash-can-outline
                      </v-icon>
                      <span v-else>削除</span>
                    </v-btn>
                  </div>
                </template>
                <!-- /削除ボタン -->

                <!-- 依頼割合設定 -->
                <template v-else-if="['edit_request_action']">
                  <!--
                    このボタンは以下のルールで表示する
                    ・マスタ編集であること
                    ・自工程直下の次工程が2つ以上存在する.
                  -->
                  <v-btn
                    v-if="member.has_sibling_children && !referenceOnly"
                    :disabled="!targetForRegistration"
                    icon
                    small
                    @click="editRequestButtonClickEvent(member)"
                  >
                    <v-icon>mdi-sitemap-outline</v-icon>
                  </v-btn>

                </template>
                <!-- /依頼割合設定 -->

              </td>
            </tr>
          </tbody>
          <tbody
            v-else
          >
          <tr class="line-space">
            <td :colspan="headers.length">
              <div class="text-center grey--text">
                データはありません
              </div>
            </td>
          </tr>
          </tbody>

        </template>

      </v-simple-table>
    </v-sheet>

    <!-- 後工程追加モーダル -->
    <choose-recycle-disposal-pattern-modal
      :enable="enableNextStepModal"
      :fixed-condition="modalConditions"
      @close="modalNegativeCallback"
      @selected="modalPositiveCallback"
    />
    <!-- /後工程追加モーダル -->

    <edit-request-ratio-modal
      :enable="enableEditRequestRatioModal"
      :result-list.sync="targetOfSiblingChildren"
      @close="modalNegativeCallback"
      @register="editRequestRatioModalCallback"
    />
  </div>
</template>

<style scoped lang="scss">
.error-border {
  border-width: 2px !important;
}

.label-font {
  font-size: 0.7rem !important;
}

.percent-font {
  font-size: 0.6rem;
}

.line-space td:hover {
  background-color: white !important;
  cursor: default !important;
}



</style>
